import axios from "../axios.config";

const state = {
  persons: [],
  new_person: {}
};

const actions = {
  async loadPersons({ commit }, params) {
    try {
      const { data } = await axios.get("/persons", {
        params
      });
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_PERSONS_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async savePersonJoin({ commit, dispatch }, params) {
    try {
      const { data } = await axios.post("/persons", params);
      if (data.success) {
        commit("SET_SAVE_PERSON_JOIN", data);
      }
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
};

const mutations = {
  SET_PERSONS_LIST: (state, persons_list) => {
    state.persons = persons_list;
  },
  SET_SAVE_PERSON_JOIN: (state, value) => {
    state.new_person = value.data;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
